import React, { useMemo } from 'react';
import { StyledCincopaContainer } from '@/components/gallery/components';

interface CincopaDefaultGalleryProps {
  fid?: string;
}

const CincopaDefaultGallery: React.FC<CincopaDefaultGalleryProps> = ({
  fid: fidProp,
}) => {
  const fid = fidProp?.trim();

  const hasValidFid = useMemo(() => Boolean(fid), [fid]);

  const iframeSrc = useMemo(
    () => (fid ? `https://rtcdn.cincopa.com/iframe.aspx?fid=${fid}` : ''),
    [fid],
  );

  if (!hasValidFid) {
    return (
      <div className="cincopa-container cincopa-placeholder">
        <p>No photos</p>
      </div>
    );
  }

  return (
    <StyledCincopaContainer>
      <div
        className="cincopa_responsive_iframe"
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          minHeight: 400,
          overflow: 'hidden',
        }}
      >
        <div
          className="cincopa_responsive_wrapper"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
          }}
        >
          <iframe
            title="PhotoGallery"
            src={iframeSrc}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              display: 'block',
            }}
            allowFullScreen
            scrolling="auto"
            allow="autoplay *; fullscreen *"
          />
        </div>
      </div>
    </StyledCincopaContainer>
  );
};

export default CincopaDefaultGallery;
